import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../core/i18n';
import { DatePickerCalendarInputModule } from '../date-picker-calendar-input/date-picker-calendar-input.module';
import { GenericLinkModule } from '../generic-link';
import { DatePickerComponent } from './date-picker.component';

@NgModule({
  imports: [
    CommonModule,
    NzIconModule,
    I18nModule,
    FormsModule,
    NgbDropdownModule,
    DatePickerCalendarInputModule,
    GenericLinkModule,
  ],
  declarations: [DatePickerComponent],
  exports: [DatePickerComponent],
})
export class DatePickerModule {}
